<template lang="pug">
  ol.ssp-breadcrumb(v-if="items")
    li(v-for="it in items")
      a(v-if="it.path" :href="it.path") {{ it.title }}
      span(v-else) {{ it.title }}
</template>

<script>
import Mustache from 'mustache'

export default {
  computed: {
    items() {
      const bcItems = this.$route.meta.breadcrumb
      if (bcItems) {
        // interpolate params
        return bcItems.map((it) => ({
          path: it.path && Mustache.render(it.path, this.$route),
          title: it.title && Mustache.render(it.title, this.$route)
        }))
      }
      return null
    }
  }
}
</script>


<style lang="scss">
.ssp-breadcrumb {
  font-size: 13px;
  border-radius: 0;
  box-shadow: 0px 0px 1px 1px #cecece;
  margin: 0 0 30px 0 !important;
  padding: 8px 15px;
  list-style: none;
  background-color: #f5f5f5;
  border-radius: 3px;

  > li {
    display: inline-block;
  }

  > li + li:before {
    content: "/\00a0";
    padding: 0 5px;
    color: #cccccc;
  }

  .active {
    color: #777777;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nav/Breadcrumb.vue